import ajax from '../utils/request';

const balanceApi = {
  /*******************************商人上分管理*********************************** */

getBalanceList(params) {
    return ajax({
      url:'/daichong/merchant/balanceList',
      type:'get',
      params
    })
  }
}
export default balanceApi;

